import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column } from '~/commonComponents/Column';
import { EmptyNewToYouProfessionalCopy } from '~/components/ProfessionalsHub/Constants';

export const NoNewToYou = () => {
  return (
    <Column alignItems="center">
      <EmptyNewToYouProfessionalCopy.Icon size={136} />

      <Typography as="span" bold color={colors.neutral[500]} size="heading_4" style={{ marginTop: 18 }}>
        {EmptyNewToYouProfessionalCopy.title}
      </Typography>
      <Typography as="span" color={colors.neutral[500]} textAlign="center" style={{ marginTop: 18, width: 399 }}>
        {EmptyNewToYouProfessionalCopy.description}
      </Typography>
    </Column>
  );
};
